// Order Number Generation System
// Generates unique 4-digit order numbers starting from 1000

const ORDER_NUMBER_KEY = 'water_tribe_fest_last_order_number'

/**
 * Generate a unique order number
 * Format: 4 digits starting from 1000 (1000, 1001, 1002, etc.)
 */
export function generateOrderNumber(): string {
  // Get last order number from localStorage
  const lastOrderNumber = localStorage.getItem(ORDER_NUMBER_KEY)

  let nextNumber: number

  if (lastOrderNumber) {
    nextNumber = parseInt(lastOrderNumber, 10) + 1
  } else {
    // Start from 1000 if no previous order exists
    nextNumber = 1000
  }

  // Save the new order number
  localStorage.setItem(ORDER_NUMBER_KEY, nextNumber.toString())

  return nextNumber.toString()
}

/**
 * Format order number for display
 * Example: 1000 -> "WTF-1000"
 */
export function formatOrderNumber(orderNumber: string): string {
  return `WTF-${orderNumber}`
}

/**
 * Get current order number without incrementing
 */
export function getCurrentOrderNumber(): string | null {
  return localStorage.getItem(ORDER_NUMBER_KEY)
}
